import { DEFAULT_FONT_FAMILY, DEFAULT_FONT_SIZE } from '@/constants';
import { Box, Input, Text, Textarea } from '@chakra-ui/react'
import React from 'react'

interface SelectReadOnlyFieldProps {
  label: string;
  value: string;
}

export const SelectReadOnlyField:React.FC<SelectReadOnlyFieldProps> = ({ label, value }) => {
  return (
    <Box>
        <Text mb={2} fontSize={DEFAULT_FONT_SIZE} fontFamily={DEFAULT_FONT_FAMILY} fontWeight="500" color="#333">
            {label}:
        </Text>
        {label?.toLowerCase() == "description"? <Textarea size="sm" value={value} readOnly/> : <Input value={value} readOnly/>}
    </Box>
  )
}

